export default "__VITE_ASSET__51075191__"